import { render } from "./CompanySeekers.vue?vue&type=template&id=f837521a&ts=true"
import script from "./CompanySeekers.vue?vue&type=script&lang=ts"
export * from "./CompanySeekers.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__